import { Button, Dialog, DialogContent, Icons } from '@commenda/kakashi';
import { ServiceRequestDetails } from '@commenda/types/src/service-request/types';
import { LegacyDocumentType } from '@prisma/client';
import { viewUploadedFile } from '../../../../utils';

type BankStatementsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  viewOnly?: boolean;
  serviceRequest: ServiceRequestDetails;
};

export const BankStatementsModal = ({
  isOpen,
  onClose,
  onSuccess,
  viewOnly = false,
  serviceRequest,
}: BankStatementsModalProps) => {
  const corporationBankStatements =
    serviceRequest?.corporation?.corporationDocuments?.find(
      (eachFile) => eachFile?.documentType === LegacyDocumentType.BankStatements
    );

  const recentlyUploadedBankStatementsFile =
    corporationBankStatements?.files.sort((a, b) => b.id - a.id)[0];

  const onSubmit = async () => {
    if (onSuccess) {
      await onSuccess();
    }

    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="p-6 flex flex-col gap-4">
        <div className="w-12 h-12 rounded-md bg-bg-primary border border-primary flex justify-center items-center">
          <Icons.File04 className="text-fg-secondary" />
        </div>
        <h3 className="text-lg-bold text-text-primary-900 mt-4">
          Verify Document
        </h3>
        <div className="bg-bg-secondary rounded-md">
          <div className="flex flex-col gap-2 py-3 px-4">
            <p className="text-sm-medium text-text-quaternary">
              Bank Statements
            </p>
            <p
              className="txt-small-bold text-utility-blue-600 flex items-center gap-1 cursor-pointer"
              onClick={() =>
                viewUploadedFile(recentlyUploadedBankStatementsFile?.id)
              }
            >
              Open document <Icons.ArrowUpRight className="size-4" />
            </p>
          </div>
        </div>
        {!viewOnly ? (
          <div className="w-full flex items-center justify-end">
            <Button type="button" onClick={onSubmit}>
              Verify
            </Button>
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};
